import { render } from "./Toolbox.vue?vue&type=template&id=0a5faa49&ts=true"
import script from "./Toolbox.vue?vue&type=script&lang=ts"
export * from "./Toolbox.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__